<template>
    <div class="webim-style-select">
        <v-page-header
            title="会话窗口样式"
            level="section"
        />

        <div class="webim-style-select__main">
            <div class="webim-style-select-left">
                <webim-style-desc
                    @component-change="handleComponentChange"
                    :color-style="colorStyle"
                    :bg-style="bgStyle"
                />
            </div>
            <div class="webim-style-select-right">
                <webim-color-select
                    :init-data="initData"
                    @change="handleChangeColor"
                />
                <v-checkbox
                    v-if="channelType !== 1 && hasAdaptThemeColorPrivilege && selectComponent === 'mobile'"
                    v-model="adaptThemeColor"
                    label="移动H5输入框互动按钮跟随主题色"
                    class="input-button-color-checkbox"
                />
                <webim-bg-select
                    v-if="channelType !== 1"
                    :init-data="initData"
                    :scale="2"
                    @confirm="handleChangePCBg"
                    title-text="电脑端背景图"
                    class="webim-bg-select--pc"
                    platform="pc"
                />
                <webim-bg-select
                    :init-data="initData"
                    :scale="3"
                    @confirm="handleChangeMobileBg"
                    title-text="移动端背景图"
                    class="webim-bg-select--mobile"
                    platform="mobile"
                />
            </div>
        </div>
    </div>
</template>
<script>
import WebimColorSelect from './webim-color-select/index';
import WebimBgSelect from './webim-bg-select/index';
import WebimStyleDesc from './webim-style-desc/index';

import { covertColorToStyle, covertBgToStyle } from './coverToStyle';
import { THEME_CONFIG } from './conf';

export default {
    components: {
        WebimColorSelect,
        WebimBgSelect,
        WebimStyleDesc,
    },
    inject: ['channelType'],
    props: {
        isDefaultTpl: {
            type: Boolean,
            default: false,
        },
        styleSelectData: {
            required: true,
            type: Object,
            default: () => {},
        },
        hasAdaptThemeColorPrivilege: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            env: window.pageData.env,
            initData: this.styleSelectData,
            colorData: {},
            bgData: {},
            colorStyle: {},
            bgStyle: {
                pc: '',
                mobile: '',
            },
            selectComponent: 'link', // 当前选中的组件  link  icon  mobile
            adaptThemeColor: false, // 输入框按钮是否适配主题色
        };
    },
    watch: {
        styleSelectData(newValue) {
            this.initData = newValue;
            this.adaptThemeColor = newValue.styleConfig.adaptThemeColor;
        },
        colorData: {
            handler(newData) {
                const theme = newData.value;
                const styleConfig = {
                    themeColor: newData.color,
                    backgroundImage: this.bgData,
                    detail: { ...covertColorToStyle(newData.color), ...covertBgToStyle(this.bgData) },
                    adaptThemeColor: this.adaptThemeColor,
                };
                if (styleConfig.detail && styleConfig.detail.receiverBubble) {
                    delete styleConfig.detail.receiverBubble;
                }
                this.$emit('getNowData', styleConfig, 'styleConfig');
                this.$emit('getNowData', theme, 'theme');
            },
            deep: true,
        },
        bgData: {
            handler(newData) {
                this.updateStyleConfig(newData);
            },
            deep: true,
        },
        adaptThemeColor: {
            handler() {
                this.updateStyleConfig(this.bgData);
            },
        },
    },
    methods: {
        updateStyleConfig(newData) {
            const styleConfig = {
                themeColor: this.colorData.color,
                backgroundImage: this.bgData,
                detail: { ...covertColorToStyle(this.colorData.color), ...covertBgToStyle(newData) },
                adaptThemeColor: this.adaptThemeColor,
            };
            if (styleConfig.detail && styleConfig.detail.receiverBubble) {
                delete styleConfig.detail.receiverBubble;
            }
            this.$emit('getNowData', styleConfig, 'styleConfig');
        },
        saveData() {
            const params = {
                theme: this.colorData.value,
                styleConfig: {
                    themeColor: this.colorData.color,
                    backgroundImage: this.bgData,
                    detail: { ...covertColorToStyle(this.colorData.color), ...covertBgToStyle(this.bgData) },
                    adaptThemeColor: this.adaptThemeColor,
                },
            };
            this.$emit('getThemBgData', params);
        },

        formatData(data = {}) {
            if (!data.styleConfig) {
                const theme = data.theme || 1;

                data.styleConfig = {
                    themeColor: `#${THEME_CONFIG[theme].color}`,
                    backgroundImage: {
                        pc: '',
                        mobile: '',
                    },
                };
            }

            if (!data.styleConfig.themeColor) {
                data.styleConfig.themeColor = `#${THEME_CONFIG[data.theme]}`;
            }

            if (!data.styleConfig.backgroundImage) {
                data.styleConfig.backgroundImage = {
                    pc: '',
                    mobile: '',
                };
            }

            return data;
        },

        handleChangeColor(data) {
            this.colorData = data;

            this.colorStyle = {
                backgroundColor: data.color,
            };
        },

        handleChangePCBg(url) {
            this.bgData = { ...this.bgData, pc: url };

            if (url) {
                this.bgStyle = {
                    ...this.bgStyle,
                    pc: {
                        backgroundImage: `url(${url})`,
                    },
                };
            } else {
                this.bgStyle = {
                    ...this.bgStyle,
                    pc: {},
                };
            }
        },

        handleChangeMobileBg(url) {
            this.bgData = { ...this.bgData, mobile: url };

            if (url) {
                this.bgStyle = {
                    ...this.bgStyle,
                    mobile: {
                        backgroundImage: `url(${url})`,
                    },
                };
            } else {
                this.bgStyle = {
                    ...this.bgStyle,
                    mobile: {},
                };
            }
        },

        handleComponentChange(selectComponent) {
            this.selectComponent = selectComponent;
        },
    },
};
</script>

<style lang="less">
@import '~@/common/common';

.webim-style-select {
    position: relative;
    padding-top: 5px;
    padding-bottom: 40px;

    & > .sub-title {
        margin-top: 5px;
    }
    &__bg {
        margin-top: 36px;
    }
    &__main{
        display: flex;
    }

    .webim-style-select-left {
        margin-right: 68px;
    }
    .webim-style-select-right {
        min-width: 750px;

        .input-button-color-checkbox {
            margin-top: var(--spacing-extra-loose);
            margin-left: 120px;
        }
    }
}

.webim-bg-select {
    &--pc {
        display: inline-block;
    }

    &--mobile {
        display: inline-block;
    }
}
</style>
